import { BsCheckCircleFill } from "react-icons/bs";
import { FiAlertTriangle } from "react-icons/fi";
import { Link } from "react-router-dom";
import { Card, CardBody, Table, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useSettings } from "../../../../../context/settings";

function AuditTab({data}) {
  const { t } = useTranslation();
  const { formatDateTime } = useSettings();
  
  return(
    <TabPane tabId="audit">
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <p className="text-muted small fw-semibold text-uppercase mb-0">{t('security.recentEvents')}</p>
            <Link to="/settings/audit-logs" className="small">{t('settings.viewAllLogs')}</Link>
          </div>
          <Table hover responsive className="mb-0">
            <thead className="table-light">
              <tr>
                <th>{t('security.time')}</th>
                <th>{t('common.email')}</th>
                <th>{t('common.status')}</th>
                <th>{t('security.ipAddress')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.map((e, i) => (
                <tr key={i}>
                  <td className="text-muted small">{formatDateTime(e.created_at)}</td>
                  <td className="text-muted small">{e.email}</td>
                  <td>{e.status}</td>
                  <td className="text-muted">{e.ip}</td>
                  <td>
                    {e.status === 'success' && <BsCheckCircleFill className="text-success" />}
                    {e.status === 'failed'  && <FiAlertTriangle className="text-danger" />}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </TabPane>
  );
}

export default AuditTab;
